<script>
	export let country;
	export let list;
	import { interventions, dataset, capacity, regionLabel, incomeLabel, capacityColor} from '../stores.js';
</script>
<header class="compare-header">
    {#if country.country}
        <h3 class="title">{country.country}</h3>
        <div class="details">
            <div class="">
                <p class="label">Region</p>
                <p class="description">{regionLabel(country.region)}</p>
            </div>
            <div class="">
                <p class="label">Income group</p>
                <p class="description">{incomeLabel(country.income)}</p>
            </div>
            <div class="">
                <p class="label">GDP per capita</p>
                <p class="description">U$ {String(parseInt(country.ppp)).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</p>
            </div>
            <div class="">
                <p class="label">expenditure on health</p>
                <p class="description">{country.p_gdp}% of GDP</p>
            </div>
        </div>
    {:else}
        <h3 class="title">{regionLabel(country.region)}</h3>
        <div class="details">
            <p class="description" style="width: 100%;">{country.count} countries with available data 
                <span class="tip">
                    <span>
                        {#each list as l}
                            <p>{l}</p>
                        {/each}
                    </span>
                </span>
            </p>
        </div>
    {/if}
</header>

{#each interventions as int}
<div class="compare-intervention" data-intervention="{int.id}">
    <div class="bar-graph big-bar" data-capacity="{Math.ceil(country[int.code])}">
        <div class="bar"><div class="base"><div class="progress"></div></div></div>
        <p class="legend">{capacity(country[int.code])}</p>
    </div>
    <ul class="elements">
    	{#each int.keyelements as kel}
        <li data-intervention="{kel.id}">
            <div class="bar-graph" data-capacity="{Math.ceil(country[kel.code])}">
                <div class="bar"><div class="base"><div class="progress"></div></div></div>
        		<p class="legend">{capacity(country[kel.code])}</p>
            </div>
        </li>
        {/each}
    </ul>
</div>
{/each}


<div class="tc wt100">
    {#if country.country}
    <a href="#/profile/{country.iso}" class="btn-text btn-text-default btn-link">View full profile</a>
    {:else}
    <!--<a href="#/profile/{country.region}" class="btn-text btn-text-default btn-link">View full profile</a>-->
    {/if}
</div>